export default {
  content: {
    general: {
      clientName: "Monument",
    },
    footerClientName: "Monument Premium Funding",
  },
};
